export enum ApiPositionProcedureExplanationCodeEnum {
    ConsequencesForAnnualBonus = 'GJBL',
    ConsequencesForClaimFreeYearsBMLadderAndPremium = 'GSBP',
    RecoverExcess = 'VHER',
    NextStepsIfThereIsCover = 'VSDE',
    NextStepsIfThereIsNoCover = 'VSGD',
}
